var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertWhiteNavyBlueBgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#0B1A8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52537 4.63558V7.20958C8.52537 7.48258 8.51187 7.75108 8.48487 8.01508C8.45787 8.27608 8.42337 8.55358 8.38137 8.84758H7.62537C7.58337 8.55358 7.54887 8.27608 7.52187 8.01508C7.49487 7.75108 7.48137 7.48258 7.48137 7.20958V4.63558H8.52537ZM7.30587 10.5306C7.30587 10.4376 7.32237 10.3491 7.35537 10.2651C7.39137 10.1811 7.43937 10.1091 7.49937 10.0491C7.56237 9.98908 7.63587 9.94108 7.71987 9.90508C7.80387 9.86908 7.89387 9.85108 7.98987 9.85108C8.08287 9.85108 8.17137 9.86908 8.25537 9.90508C8.33937 9.94108 8.41137 9.98908 8.47137 10.0491C8.53437 10.1091 8.58387 10.1811 8.61987 10.2651C8.65587 10.3491 8.67387 10.4376 8.67387 10.5306C8.67387 10.6266 8.65587 10.7166 8.61987 10.8006C8.58387 10.8816 8.53437 10.9521 8.47137 11.0121C8.41137 11.0721 8.33937 11.1186 8.25537 11.1516C8.17137 11.1876 8.08287 11.2056 7.98987 11.2056C7.89387 11.2056 7.80387 11.1876 7.71987 11.1516C7.63587 11.1186 7.56237 11.0721 7.49937 11.0121C7.43937 10.9521 7.39137 10.8816 7.35537 10.8006C7.32237 10.7166 7.30587 10.6266 7.30587 10.5306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWhiteNavyBlueBgCircle);
export default __webpack_public_path__ + "static/media/alertWhiteNavyBlueBgCircle.032ed29c7805d3d11846ebf743b7f60d.svg";
export { ForwardRef as ReactComponent };